/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ExportHistoryItemSchema } from './exportHistoryItemSchema';

export interface ExportHistoryListSchema {
  exports: ExportHistoryItemSchema[];
  total: number;
  page: number;
  per_page: number;
}
